// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3dNKz","vLegacy":"SelectSecondary_vLegacy__3Iroz","error":"SelectSecondary_error__26-Ul","disabled":"SelectSecondary_disabled__2Olzd"};